/***
 *
 *   SUB NAV STYLES
 *   `tabs` is the reference's underline TabsList
 *   (ui-reference/src/components/ui/tabs.tsx); `rail` is its vertical
 *   SettingsNav (ui-reference/src/components/settings/settings-nav.tsx).
 *
 *   Replaces sub.scss, which drew the rail with negative margins pulled off the
 *   old layout's padding ($scale2*-1) and a $c-main-light underline.
 *
 **********/

const Style = {
    tabs: {
        nav: 'flex items-center gap-1 overflow-x-auto border-b border-border',
        item: `inline-flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 border-transparent
        px-3 py-2 text-sm font-medium transition-all
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
        itemActive: 'border-primary-600 text-primary-700 dark:text-primary-300',
        itemIdle: 'text-text-secondary hover:text-text-primary',
    },

    rail: {
        nav: 'flex flex-col gap-1',
        item: `flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium transition-colors
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring`,
        itemActive: 'bg-primary-100 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
        itemIdle: 'text-text-secondary hover:bg-muted hover:text-text-primary',
    },

    alert: 'ml-auto shrink-0',
};

export default Style;
